import * as React from 'react';
import InputComponent from './InputComponent';

interface INameState {
    hasError: boolean
    nameValue: string
}

interface INameProps {
    id?: string
    content: any
    validateInput(inputID: string, isCorrect: boolean): any,
    onValueChange(value: string): void
}


class NameInput extends React.Component<INameProps, INameState> {

    constructor(props: INameProps) {
        super(props);
        this.state = {
            hasError: false,
            nameValue: '',
        }

        this.handleError = this.handleError.bind(this)
        this.changeInputValue = this.changeInputValue.bind(this)
        this.validateNameInput = this.validateNameInput.bind(this)
        this.preventSpecificKeys = this.preventSpecificKeys.bind(this)
    }

    public changeInputValue(input: string): void {
        this.setState({
            nameValue: input
        }, () => {
            if (this.state.hasError) {
                this.handleError()
            } else {
                this.validateNameInput()
            }

            this.props.onValueChange(input);
        })
    }
    public handleError(): void {
        if (this.state.nameValue.length) {
            this.setState({
                hasError: false
            }, () => {
                this.validateNameInput()
            })
        } else if (!this.state.nameValue.length) {
            this.setState({
                hasError: false
            }, () => {
                this.validateNameInput()
            })
        } else {
            this.setState({
                hasError: true
            })
        }
    }

    public validateNameInput(): void {
        if (!this.state.hasError && this.state.nameValue.length) {
            this.props.validateInput('name', true)
        } else {
            this.props.validateInput('name', false)
        }
    }

    public preventSpecificKeys(e: React.KeyboardEvent): any {
        const nameRegex = /^[a-zA-ZàáâäãåąčćęèéêëėįìíîïłńòóôöõøùúûüųūÿýżźñçčšžÀÁÂÄÃÅĄĆČĖĘÈÉÊËÌÍÎÏĮŁŃÒÓÔÖÕØÙÚÛÜŲŪŸÝŻŹÑßÇŒÆČŠŽ∂ð\s'-]+$/;
        if (!nameRegex.test(e.key)) {
            e.preventDefault()
            return false
        }
        return true
    }


    public render() {
        if (this.props.content === null) {
            return null
        }

        return (
            <InputComponent
                id={this.props.id}
                inputValue={this.state.nameValue}
                hasError={this.state.hasError}
                placeholder={this.props.content.nameInputLabel}
                errorMessage={this.props.content.nameInputError}
                maxLength={255}
                changeInputValue={this.changeInputValue}
                checkInput={this.handleError}
                preventSpecificKeys={this.preventSpecificKeys} />
        )
    }
}

export default NameInput





// WEBPACK FOOTER //
// ./src/components/Inputs/NameInput.tsx